
export const validationMessages = {
  undefined: () => `Something went wrong.`,
  required: (label) => `${label} is required.`,
  invalidUrlOrId: () => `This Youtube URL or ID is invalid.`,
  maxVideoLength: () => `This video is too long.`,
  noCaptions: () => `This video has no captions.`,
};
